module.exports = __webpack_public_path__ + "media/live-superposition.d927af9f.mp4";